/* eslint-disable */
export const contacts = [
    {
        id: 'cd5fa417-b667-482d-b208-798d9da3213c',
        background: 'images/cards/ftsln1.jpg',
        avatar: '',
        name: 'Ostrava, Nová Karolina',
        emails: [
            {
                email: 'info@witova.cz',
                label: 'Work',
            }
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '733 213 273',
                label: 'Work',
            }
        ],
        address: '28. října 3348/65, 702 00, Moravská Ostrava',
        openingHours: 'po–pá: 8.00 – 20.00 | so: 8.00 – 16.00',
        notes: 'těšíme se na vás',
    },
    {
        id: 'beec5287-ed50-4504-858a-5dc3f8ce6935',
        background: null,
        name: 'Havířov',
        emails: [
            {
                email: 'info@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '605 830 551',
                label: 'Mobile',
            },
        ],
        address: 'Nám. Republiky 1521, 736 01, Havířov',
        openingHours: 'po–pá: 8.00 – 20.00 | so: 8.00 – 16.00',
        notes: 'jsme na náměstí',
    },
];

export const tags = [
    {
        id: 'c31e9e5d-e0cb-4574-a13f-8a6ee5ff8309',
        title: 'Work',
    },
    {
        id: 'a8991c76-2fda-4bbd-a718-df13d6478847',
        title: 'Friend',
    },
    {
        id: '56ddbd47-4078-4ddd-8448-73c5e88d5f59',
        title: 'Family',
    },
    {
        id: '2026ce08-d08f-4b4f-9506-b10cdb5b104f',
        title: 'High School',
    },
    {
        id: '65930b5a-5d2a-4303-b11f-865d69e6fdb5',
        title: 'College',
    },
    {
        id: '3eaab175-ec0d-4db7-bc3b-efc633c769be',
        title: 'Baseball Team',
    },
    {
        id: 'cbde2486-5033-4e09-838e-e901b108cd41',
        title: 'Band',
    },
];
